define.alias("ember-math-helpers/helpers/sin", "preview-grid/helpers/sin");